'use client'
import { eventPublisher } from '@/utils/event-publisher'
import { useEffect } from 'react'

export default function ObservabilityInit() {
    useEffect(() => {
        if (window) eventPublisher.initObservability()
    }, [])
    return null
}
